import React from "react";
import { AiOutlineHeart } from "react-icons/ai";
import { createSearchParams, useNavigate } from "react-router-dom";

interface Props {
  id: string;
  img: string;
  tekkingTitle: string;
  day: number;
  night: number;
}
const FeaturedTrekkingCard = ({ id, img, tekkingTitle, day, night }: Props) => {
  let navigate = useNavigate();
  const handleRoute = (searchParam: {} | null) => {
    // setActivePage(`${route["nav-item"]}`)
    if (searchParam) {
      navigate({
        pathname: "/package-details",
        search: createSearchParams(searchParam).toString(),
      });
    } else {
      navigate({
        pathname: "/package-details",
      });
    }
  };

  return (
    <div onClick={() => handleRoute({ pkg: id })}>
      <div className="group h-72 lg:h-80 xl:h-96 shadow-lg rounded-md overflow-hidden relative cursor-pointer">
        <div className="h-full w-full relative">
          <img
            src={`${process.env.REACT_APP_API}/uploads/images/${img}`}
            alt={tekkingTitle}
            srcSet=""
            className="h-full w-full object-cover transition ease-linear duration-200 group-hover:scale-105"
          />
          <div className="bg-white text-primary-base w-fit px-4 py-1 absolute top-5 z-10 text-sm rounded-tr-full rounded-br-full flex items-center space-x-2">
            <AiOutlineHeart />
            <p>Featured</p>
          </div>
          <div className="h-full w-full bg-gradient-to-t from-gray-900 absolute top-0"></div>
        </div>
        <div className="absolute bottom-[15%] max-w-full  px-4 lg:px-5">
          <h1 className="text-white font-semibold text-lg w-full line-clamp-2">
            {tekkingTitle}
          </h1>
        </div>
        <p className="text-secondary-base text-sm ml-6 -mt-10 absolute">
          {day}D | {night}N
        </p>
      </div>
    </div>
  );
};

export default FeaturedTrekkingCard;
